import { render } from "./SectionRace.vue?vue&type=template&id=befdf10c&scoped=true"
import script from "./SectionRace.vue?vue&type=script&lang=js"
export * from "./SectionRace.vue?vue&type=script&lang=js"

import "./SectionRace.vue?vue&type=style&index=0&id=befdf10c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befdf10c"]])

export default __exports__